import { Redirect, useParams } from "react-router-dom";

export default function ClientRedirect(){
    const params: any = useParams();

    return <Redirect to={`/${params.clientCodename}/events`} />
}